import React from "react";
import { CheckCheck, MessageCircleHeart } from "lucide-react";
import { WALL_ROW_1, WALL_ROW_2 } from "../data/mockWall";
import { useReveal } from "../hooks/useReveal";

function Bubble({ item }) {
  if (item.type === "img") {
    return (
      <div className="shrink-0 w-52 md:w-60 rounded-2xl overflow-hidden ring-1 ring-white/10 glass">
        <img src={item.src} alt="témoignage écran" className="w-full h-full object-cover" loading="lazy" />
      </div>
    );
  }
  return (
    <div className="shrink-0 w-64 md:w-72 glass rounded-2xl p-4 whitespace-normal">
      <div className="flex items-center gap-2.5 mb-2">
        <span className="w-8 h-8 rounded-full bg-gradient-to-br from-[#1f6f8b] to-[#5a5ee0] flex items-center justify-center text-white text-xs font-semibold shrink-0">
          {item.name.charAt(0)}
        </span>
        <span className="text-sm text-white font-medium truncate">{item.name}</span>
        <span className="ml-auto text-[10px] text-white/40 shrink-0">{item.time}</span>
      </div>
      <p className="text-[13px] text-white/75 leading-relaxed whitespace-normal break-words">{item.text}</p>
      <div className="mt-2 flex justify-end">
        <CheckCheck className="w-3.5 h-3.5 text-[#38bdf8]" />
      </div>
    </div>
  );
}

function Row({ items, reverse }) {
  const doubled = [...items, ...items];
  return (
    <div className="pause-on-hover overflow-hidden">
      <div className={`marquee-track ${reverse ? "marquee-reverse" : ""} gap-4`}>
        {doubled.map((item, i) => (
          <div key={i} className="mx-2">
            <Bubble item={item} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function ProofWall() {
  const head = useReveal();
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <div ref={head} className="reveal flex items-center justify-center gap-2 mb-10 px-5">
        <MessageCircleHeart className="w-5 h-5 text-[#7fd8e8]" />
        <p className="eyebrow text-white/55 text-xs text-center">Mur de preuves · leurs messages au quotidien</p>
      </div>
      <div className="space-y-4">
        <Row items={WALL_ROW_1} reverse={false} />
        <Row items={WALL_ROW_2} reverse={true} />
      </div>
      {/* edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#060b18] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#060b18] to-transparent" />
    </section>
  );
}
